import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import dayjs from 'dayjs';
import { Colors, MediaBreakPointUp, Sizes } from '@lean-body/components/styles';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LocalStorage, LocalStorageType, SessionStorage } from '@lean-body/src/infra';
import { generateLessonQueryParams, LessonType, routes } from '@lean-body/src/route';
import { isAndroidApp } from '@lean-body/src/util';
import { GoalMatchingAssessmentEnableNotifications } from './goal_matching_assessment_enable_notifications';
import { GOAL_MATCHING_ASSESSMENT_VERSION } from '../pages/main_goal_matching_assessment';
import { GoalMatchingAssessmentHeader } from '../molecules/goal_matching_assessment_header';
import { GoalMatchingAssessmentResultConfirm } from './goal_matching_assessment_result_confirm';
import { GoalMatchingAssessmentResultButtons } from '../molecules/goal_matching_assessment_result_buttons';
import { GoalMatchingAssessmentResultAdvice } from './goal_matching_assessment_result_advice';
import { GoalMatchingAssessmentResultFinish } from './goal_matching_assessment_result_finish';
import { GoalMatchingAssessmentResultReady } from './goal_matching_assessment_result_ready';
import { GoalMatchingAssessmentResultLetsTry } from './goal_matching_assessment_result_lets_try';
var GoalMatchingAssessmentResultState;
(function (GoalMatchingAssessmentResultState) {
    GoalMatchingAssessmentResultState[GoalMatchingAssessmentResultState["Ready"] = 0] = "Ready";
    GoalMatchingAssessmentResultState[GoalMatchingAssessmentResultState["Confirm"] = 1] = "Confirm";
    GoalMatchingAssessmentResultState[GoalMatchingAssessmentResultState["Advice"] = 2] = "Advice";
    GoalMatchingAssessmentResultState[GoalMatchingAssessmentResultState["LetsTry"] = 3] = "LetsTry";
    GoalMatchingAssessmentResultState[GoalMatchingAssessmentResultState["Finished"] = 4] = "Finished";
    GoalMatchingAssessmentResultState[GoalMatchingAssessmentResultState["RequestNotificationPermissions"] = 5] = "RequestNotificationPermissions";
})(GoalMatchingAssessmentResultState || (GoalMatchingAssessmentResultState = {}));
export const GoalMatchingAssessmentResult = ({ apiClient, config, userName, currentAnswers, isWeightKeeping, isReassessment, setProfile, onClickBackForResult, classObject, }) => {
    const navigate = useNavigate();
    const sessionStorage = new SessionStorage();
    const localStorage = new LocalStorage();
    const startLoadingTime = Date.now();
    const [state, setState] = useState(GoalMatchingAssessmentResultState.Ready);
    const [result, setResult] = useState();
    const [goalDate, setGoalDate] = useState();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const params = {
            answers: currentAnswers.filter(Boolean),
            version: GOAL_MATCHING_ASSESSMENT_VERSION,
            courseCode: localStorage.loadObjByKey(LocalStorageType.CourseCode),
        };
        const fetchResult = apiClient.fetchGoalMatchingAssessmentResult(params);
        fetchResult.then((result) => {
            setResult(result);
            setGoalDate(dayjs.unix(Number(result.goalDate)));
            // ページ読み込み時から最低2秒はローディングを表示する
            const elapsedTime = Date.now() - startLoadingTime;
            const remainingTime = Math.max(0, 2000 - elapsedTime);
            setTimeout(() => {
                setIsLoading(false);
            }, remainingTime);
            localStorage.removeKey(LocalStorageType.CourseCode);
            apiClient.fetchMypageProfile().then((v) => {
                setProfile(v);
            });
        });
    }, []);
    const navigateToLessonWithDailyStartId = () => {
        const targetLesson = result.firstLesson;
        const url = routes.LESSON.compile({ type: LessonType.normal, slug: targetLesson.slug });
        const params = generateLessonQueryParams(targetLesson.courseLessonID);
        navigate(`${url}${params}`);
    };
    const onClickNextButton = () => {
        switch (state) {
            case GoalMatchingAssessmentResultState.Ready:
                setState(GoalMatchingAssessmentResultState.Confirm);
                break;
            case GoalMatchingAssessmentResultState.Confirm:
                setState(GoalMatchingAssessmentResultState.Advice);
                break;
            case GoalMatchingAssessmentResultState.Advice:
                setState(GoalMatchingAssessmentResultState.LetsTry);
                break;
            case GoalMatchingAssessmentResultState.LetsTry:
                if (isReassessment) {
                    navigate(routes.TOP.compile());
                }
                else {
                    setState(GoalMatchingAssessmentResultState.Finished);
                }
                break;
            case GoalMatchingAssessmentResultState.Finished:
                if (isAndroidApp() && !sessionStorage.loadAndroidDeviceNotificationPermission()) {
                    setState(GoalMatchingAssessmentResultState.RequestNotificationPermissions);
                }
                else {
                    navigateToLessonWithDailyStartId();
                }
                break;
            default:
                setState(GoalMatchingAssessmentResultState.Finished);
        }
    };
    const onCliclBackHeader = () => {
        switch (state) {
            case GoalMatchingAssessmentResultState.Advice:
                setState(GoalMatchingAssessmentResultState.Confirm);
                break;
            case GoalMatchingAssessmentResultState.Finished:
                setState(GoalMatchingAssessmentResultState.Advice);
                break;
            case GoalMatchingAssessmentResultState.LetsTry:
                setState(GoalMatchingAssessmentResultState.Advice);
                break;
            default:
                onClickBackForResult();
        }
    };
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(GoalMatchingAssessmentHeader, { onClickBack: onCliclBackHeader, hideProgress: true, classObject: styles.header }),
        state === GoalMatchingAssessmentResultState.Ready ? (React.createElement(React.Fragment, null,
            React.createElement(GoalMatchingAssessmentResultReady, { userName: userName, isLoading: isLoading, classObject: styles.contentForRedy }),
            React.createElement("div", { className: css(styles.buttonContainer) }, !isLoading && (React.createElement(GoalMatchingAssessmentResultButtons, { primaryText: "\u6B21\u3078", onClickPrimary: onClickNextButton }))))) : state === GoalMatchingAssessmentResultState.Confirm ? (React.createElement(React.Fragment, null,
            React.createElement(GoalMatchingAssessmentResultConfirm, { config: config, userName: userName, isWeightKeeping: isWeightKeeping, result: result, goalDate: goalDate, classObject: styles.content }),
            React.createElement(GoalMatchingAssessmentResultButtons, { primaryText: "\u3053\u306E\u76EE\u6A19\u3067\u9811\u5F35\u308B\uFF01", onClickPrimary: onClickNextButton }))) : state === GoalMatchingAssessmentResultState.Advice ? (React.createElement(React.Fragment, null,
            React.createElement(GoalMatchingAssessmentResultAdvice, { classObject: styles.content }),
            React.createElement(GoalMatchingAssessmentResultButtons, { primaryText: "OK\uFF01", onClickPrimary: onClickNextButton }))) : state === GoalMatchingAssessmentResultState.LetsTry ? (React.createElement(React.Fragment, null,
            React.createElement(GoalMatchingAssessmentResultLetsTry, { classObject: styles.content, message: "\u6BCE\u65E51\u3064\u4EE5\u4E0A\u30AF\u30EA\u30A2\u3057\u3066\u9023\u7D9A\u8A18\u9332\u3092\u66F4\u65B0\u3057\u7D9A\u3051\u307E\u3057\u3087\u3046\uD83D\uDD25", shouldAnimateListItems: true }),
            React.createElement(GoalMatchingAssessmentResultButtons, { primaryText: "\u4ECA\u65E5\u304B\u3089\u59CB\u3081\u308B\uFF01", onClickPrimary: onClickNextButton }))) : state === GoalMatchingAssessmentResultState.Finished ? (React.createElement(React.Fragment, null,
            React.createElement(GoalMatchingAssessmentResultFinish, { classObject: styles.content, userName: userName, lesson: result.firstLesson }),
            React.createElement(GoalMatchingAssessmentResultButtons, { primaryText: "\u30EC\u30C3\u30B9\u30F3\u3092\u59CB\u3081\u308B", onClickPrimary: onClickNextButton }))) : (state === GoalMatchingAssessmentResultState.RequestNotificationPermissions && (React.createElement(React.Fragment, null,
            React.createElement(GoalMatchingAssessmentEnableNotifications, { allowedNotificationPermission: () => navigateToLessonWithDailyStartId(), classObject: styles.content }))))));
};
const styles = StyleSheet.create({
    container: {
        background: Colors.BackgroundAi,
        minHeight: `max(780px, calc(100vh - ${Sizes.MobileHeaderHeight}px))`,
        [MediaBreakPointUp.MD]: {
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
    },
    header: {
        marginLeft: 12,
        marginRight: 12,
        marginBottom: 50,
    },
    content: {
        [MediaBreakPointUp.MD]: {
            maxWidth: 327,
            margin: '0 auto',
        },
    },
    contentForRedy: {
        [MediaBreakPointUp.XS]: {
            width: '100%',
            position: 'fixed',
            top: '50%;',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        [MediaBreakPointUp.MD]: {
            position: 'relative',
        },
    },
    buttonContainer: {
        height: 80,
    },
});
